import { render, staticRenderFns } from "./animation.vue?vue&type=template&id=b8f70226&"
import script from "./animation.vue?vue&type=script&lang=js&"
export * from "./animation.vue?vue&type=script&lang=js&"
import style0 from "./animation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports